import React from "react";
import { string } from "prop-types";

const NavigateIcon = ({ color = "#001246" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
    <defs />
    <path
      id="Path_155"
      fill="none"
      stroke={color}
      d="M13.667 13.667H4.333V4.333h3.81V3h-3.81A1.333 1.333 0 0 0 3 4.333v9.333A1.333 1.333 0 0 0 4.333 15h9.333A1.337 1.337 0 0 0 15 13.667v-3.81h-1.333zM10.333 3v1.333h2.393l-6.553 6.554.94.94 6.553-6.553v2.393H15V3z"
      dataname="Path 155"
      transform="translate(-3 -3)"
    />
  </svg>
);

NavigateIcon.propTypes = {
  color: string
};

export default NavigateIcon;
